import React from 'react';
import { XCircle } from 'lucide-react';
export function WhyTheyFail() {
  const cards = [{
    title: 'DIETAS SIN AZÚCAR',
    desc: 'Suprimir no es resolver. El antojo vuelve con el doble de intensidad. Siempre.'
  }, {
    title: 'RECETARIOS FIT DE INSTAGRAM',
    desc: 'Diseñados para otro mercado. Ingredientes imposibles de conseguir. Recetas que no saben a nada.'
  }, {
    title: 'LA NUTRICIONISTA TRADICIONAL',
    desc: 'El plan funciona mientras pagás. Cuando el seguimiento termina, los hábitos también.'
  }, {
    title: 'LA FUERZA DE VOLUNTAD',
    desc: 'Es un recurso finito. Para la noche ya está agotada. Pelear contra tu biología no es una estrategia. Es un desgaste.'
  }];
  return <section className="bg-chocolate-900 py-20 px-4" data-id="element-380">
      <div className="max-w-5xl mx-auto" data-id="element-381">
        <h2 className="text-3xl md:text-4xl font-bold text-chocolate-50 text-center mb-12" data-id="element-382">
          ¿Por qué nada funcionó antes?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-383">
          {cards.map((card, idx) => <div key={idx} className="bg-chocolate-800 p-8 rounded-2xl border border-chocolate-800/50 shadow-lg" data-id="element-384">
              <div className="flex items-center space-x-3 mb-4" data-id="element-385">
                <XCircle className="w-6 h-6 text-pain" data-id="element-386" />
                <h4 className="text-xl font-bold text-chocolate-50" data-id="element-387">
                  {card.title}
                </h4>
              </div>
              <p className="text-chocolate-50/80 text-lg" data-id="element-388">{card.desc}</p>
            </div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-389">
          <p className="text-xl md:text-2xl text-chocolate-50 font-medium" data-id="element-390">
            Todas te piden que luches contra tu cuerpo.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-gold-400 mt-2" data-id="element-391">
            El Método Antídoto hace lo opuesto.
          </p>
        </div>
      </div>
    </section>;
}